// extracted by mini-css-extract-plugin
export default {"globalFilterInput":"tableFilters_globalFilterInput__jxIY-","columnFilterInput":"tableFilters_columnFilterInput__rW0Ee","columnFilterSelect":"tableFilters_columnFilterSelect__GWZMV"};